<template>
  <div class="main">
    <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
      <!-- Indicators -->
      <ol class="carousel-indicators">
        <li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
        <li data-target="#carousel-example-generic" data-slide-to="1"></li>
        <li data-target="#carousel-example-generic" data-slide-to="2"></li>
        <li data-target="#carousel-example-generic" data-slide-to="3"></li>
      </ol>
      <!-- Wrapper for slides -->
      <div class="carousel-inner" role="listbox">
        <div class="item active" :style="'background-image: url('+banner1+');'"></div>
        <div class="item" :style="'background-image: url('+banner2+');'"></div>
        <div class="item" :style="'background-image: url('+banner3+');'"></div>
        <div class="item" :style="'background-image: url('+banner4+');'"></div>
      </div>
    </div>
    <div class="about-box">
      <div class="container">
        <h2 class="inBox-til text-center">
          关于我们
          <span>About Us</span>
        </h2>
        <div class="details">
          <p>{{$website_name}}是一家致力于不锈钢丝网及深加工产品，集研发、生产、销售于一体的工贸一体化企业。生产基地位于中国丝网之乡河北省安平县南部工业园12号。</p><br>
          <p>主要产品：不锈钢筛网、不锈钢过滤网、轧花网、席型网、反差网，我厂还可以根据行业要求定做各种规格过滤网片、过滤网筒、塑料颗粒过滤网、橡胶过滤网等深加工产品。</p><br>
          <p>公司生产设备全部采用国际先进的数控剑杆及剑带织机，严格按照市场和消费者的要求进行高效生产，保证产品质量，满足消费者的期望，真正做到高品质，工厂价。</p><br>
		  <p>产品广泛应用于石油、汽车、化工、食品、医药等行业的过滤，产品远销欧美、东南亚等国家和地区。</p><br>
          <p>我们将提供完善的产品，有竞争力的价格和优良的服务，让客户成功和满意是我们最大的使命。</p><br>
		  <p>我们真诚地希望能与国内外友人在互惠互利的基础上建立良好的合作关系。我们会尽最大努力来满足客户的需求。</p><br>
        </div>
      </div>
    </div>
    <div class="infactroy-box">
		<h2 class="inBox-til text-center">
		  工厂区域
		  <span>Professional focus on achievement</span>
		</h2>
		<div class="row">
		  <div class="col-sm-3">
			<a href="javascript:;" class="pic-box mb12"><img :src="image_url_prefix+factory_data[1].pics[8].url"   /></a>
			<a href="javascript:;" class="pic-box"><img :src="image_url_prefix+factory_data[2].pics[0].url"   /></a>
		  </div>
		  <div class="col-sm-6">
			<a href="javascript:;" class="pic-box big-pic"><img :src="image_url_prefix+factory_data[0].pics[0].url"  /></a>
		  </div>
		  <div class="col-sm-3">
			<a href="javascript:;" class="pic-box mb12"><img :src="image_url_prefix+factory_data[3].pics[0].url"  /></a>
			<a href="javascript:;" class="pic-box"><img :src="image_url_prefix+factory_data[1].pics[4].url"  /></a>
		  </div>
		</div>
    
    </div>
    <div class="inPro-box">
      <div class="container">
        <h2 class="inBox-til">
          产品&服务
          <span>Professional focus on achievement</span>
          <router-link to="/productDetail" class="more">+ 了解更多</router-link>
        </h2>
		
        <div class="row">
          <div class="col-sm-4">
            <div class="inPro-item">
              <a href="javascript:;" @click="toProducts(1)">
                <div class="pic-box">
                  <img src="../assets/img/products/fkw/2.jpg" alt="" />
                </div>
                <h4>【厂家直销】304不锈钢网 平织 可深加工</h4>
                <!-- <span class="btn-border">点击查看详情</span> -->
              </a>
            </div>
          </div>
		  
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(2)">
		        <div class="pic-box">
		          <img src="../assets/img/products/yhw/5.jpg" alt="" />
		        </div>
		        <h4>【现货供应】304 轧花网 防护网 可深加工</h4>
		       <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		  
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(3)">
		        <div class="pic-box">
		          <img src="../assets/img/products/xxw/10.jpg" alt="" />
		        </div>
		        <h4>316密文网 平纹编织 可深加工裁条裁条</h4>
		        <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
        </div>
		
		
		<div class="row">
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(4)">
		        <div class="pic-box">
		          <img src="../assets/img/products/fcw/1.jpg" alt="" />
		        </div>
		        <h4>反差席型网 荷兰布 自动过滤席型网</h4>
		       <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		  
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(12)">
		        <div class="pic-box">
		          <img src="../assets/img/products/zsw/1.jpg" alt="" />
		        </div>
		        <h4>装饰网 室内隔断编织网 拉伸金属孔直销</h4>
		        <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		  
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(7)">
		        <div class="pic-box">
		          <img src="../assets/img/products/jgw/1.jpg" alt="" />
		        </div>
		        <h4>304金刚网 不锈钢网片 编织网 </h4>
		        <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		</div>
		
		<div class="row">
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(9)">
		        <div class="pic-box">
		          <img src="../assets/img/products/dhw/2.jpg" alt="" />
		        </div>
		        <h4>电焊网 热镀锌焊接网 抹墙网养殖网防坠网</h4>
		        <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		  
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(5)">
		        <div class="pic-box">
		          <img src="../assets/img/products/sjg/1.jpg" alt="" />
		        </div>
		        <h4>网片 筛片 滤片 方形 单层 多层 复合网</h4>
		       <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		  
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;">
		        <div class="pic-box">
		          <img src="../assets/img/products/cs/1.jpg" alt="" @click="toProducts(6)"/>
		        </div>
		        <h4>不锈钢窗纱 防蚊网 防虫网</h4>
<!-- 		        <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		  
		</div>
		
		<div class="row">
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(11)">
		        <div class="pic-box">
		          <img src="../assets/img/products/gbw/1.jpg" alt="" />
		        </div>
		        <h4>钢板网 菱形金属网 板风机扇用网 铁丝网</h4>
		        <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		  
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(8)">
		        <div class="pic-box">
		          <img src="../assets/img/products/sw/1.jpg" alt="" />
		        </div>
		        <h4>不锈钢绳网 菱形网 金属装饰网 围挡</h4>
		       <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		  
		  <div class="col-sm-4">
		    <div class="inPro-item">
		      <a href="javascript:;" @click="toProducts(10)">
		        <div class="pic-box">
		          <img src="../assets/img/products/ckw/1.jpg" alt="" />
		        </div>
		        <h4>冲孔网</h4>
		       <!-- <span class="btn-border">点击查看详情</span> -->
		      </a>
		    </div>
		  </div>
		</div>
		
		
      </div>
    </div>
  </div>
</template>

<script>
	import factory_data from "../assets/data/factory_data";
    import banner1 from "../assets/img/banner1.jpg";
    import banner2 from "../assets/img/banner2.jpg";
    import banner3 from "../assets/img/banner3.jpg";
    import banner4 from "../assets/img/banner4.jpg";
export default {
    name: 'Index',
    data:function () {
        return {
			factory_data:factory_data,
            banner1: banner1,
            banner2: banner2,
            banner3: banner3,
            banner4: banner4
        }
    },
	created:function()
	{
	},
    methods:{
        toProducts:function (index) {
            sessionStorage.setItem("__selected_category__",index);
            this.$router.push("/productDetail");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index.vue